<div>
  <app-sidebar [visible]="visible" [mode]="mode"> </app-sidebar>

  <app-header
    [isMenuOpen]="mode == 'overlay' && visible"
    (sidebarToggled)="toggleSidebar()"
  ></app-header>
  <main
    [ngClass]="visible ? 'xl:w-[calc(100%-256px)] xl:ms-[256px]' : 'w-full'"
  >
    <div id="main-page" class="p-4">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
